<template>
    <div>
  


      <el-table
    :data="tableData"
    stripe
    style="width: 100%"
    height="750"
    >
    <el-table-column
      prop="id"
      label="序号"
      width="180">
    </el-table-column>
    <el-table-column
      prop="device_number"
      label="设备"
      width="180">
    </el-table-column>

    <el-table-column
      prop="user_id"
      label="user"
      width="180">
    </el-table-column>

    <el-table-column
      prop="product_id"
      label="车型"
      width="180">
    </el-table-column>
    <el-table-column
      prop="active_time"
      label="激活时间">
    </el-table-column>

  </el-table>


  
    </div>
  </template>
  
  <script>



export default {
    data() {
      return {
        tableData: []
      }
    },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/fb_device_user").then( (response)=>  {
this.tableData = response.data
    console.log(response.data)
  })
},

mounted:function(){
  console.log("deviceActivate   挂载完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  